// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__4u6bF","footer":"Form_footer__EKYt7"};